import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import { api_gateway } from '../../../conexoes/api';
import { setaDropdown } from '../../../utils/alternanciaIcones';
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js';
export default function SelectPerfil(props) {
    const [spinAtivo, setSpinAtivo] = useState(true);
    const [lsPerfils, setLsPerfils] = useState([])
    const modal = useRef();

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };

    function handlePerfil(codigo, perfil, customizado){
        props.setCdPerfil(codigo)
        props.setDsPerfil(perfil)
        props.setCustomizado(customizado)
        handleCancelar()
    }

    function handleCancelar(){
        props.setRevelarSelectPerfil(false)
    }

    useEffect(() => {
        setSpinAtivo(true)
        async function renderPerfils(){
            let consultaPerfilPadrao = await api_gateway.get('/m1/consultar/perfil?fl_atribuivel=1&fl_customizado=0');            
            if(consultaPerfilPadrao.data.dados.length > 0){
                let objetoPerfils = consultaPerfilPadrao.data.dados.map((item,i) => {
                    return (
                        <li key={"menu-"+item.ds_pav_perfil}>
                            <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handlePerfil(item.cd_pav_perfil, item.ds_pav_perfil, item.fl_customizado) }>
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">{item.ds_pav_perfil}</span>
                            </div>
                            {consultaPerfilPadrao.data.dados[i+1]!=undefined&&<div className="campo-select-divisor-cor-1 campo-select-divisor" />}
                        </li>
                    );
                })
                setLsPerfils(objetoPerfils)
            }else{
                let objetoPerfils = () => {
                    return (
                        <li>
                            <div disabled className="campo-select-opcao campo-select-opcao-1">
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Nenhuma informação encontrada</span>
                            </div>
                        </li>
                    );
                }
                setLsPerfils(objetoPerfils)
            }
            setSpinAtivo(false)
        }
        renderPerfils()
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }  
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select" onClick={() => props.setRevelarSelectPerfil(false)}>
                <div className="fonte-cor-1 label-campo">{props.dsPerfil}</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
            <div className="campo-texto-cor-3 campo-select-corpo">
                <ul className="campo-select-lista">
                    {lsPerfils}
                </ul>
            </div>
        </Form>
    )
}